import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { H1 } from '@btc-snxt/ui';
import { useTabsContext } from 'components/Tabs/TabsContext';
import { StyledFaqSettings } from './FaqSettings.style';

const FaqSettings: React.FC = () => {
  const { t } = useTranslation();

  const tabsContext = useTabsContext();

  useEffect(() => {
    tabsContext.setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <StyledFaqSettings>
        <H1>{t('settings.faq')}</H1>
      </StyledFaqSettings>
    </>
  );
};

export default FaqSettings;
